module.exports = __webpack_public_path__ + "static/media/IMG_1494.c7bbe770.JPG";